import { Typography } from '@mui/material';
import styledComponent from 'styled-components';

export const Title = styledComponent(Typography)`
  font-size: 16px;
  font-weight: 450;
`;
